import React from 'react';

/**
 * Шапка секції головної.
 *
 * Цей блок був скопійований у шість секцій і за час правок розійшовся у
 * дрібницях: у чотирьох заголовок починався з 48px, у двох з 60px, відступи
 * під шапкою відрізнялися втричі. Кожна дрібниця непомітна, разом вони й
 * давали відчуття, що секції зібрані різними руками.
 *
 * Розмір заголовка — стеля 40px: він лишається найбільшим елементом секції,
 * але не її головним вмістом. Капс живе тільки в рубриці над заголовком, де
 * він і працює як рубрика: 12px і два-три слова.
 *
 * `tone` — світла секція чи темна. Головна чергує білі й темно-сині розділи,
 * і та сама шапка має читатися на обох тлах: на темному — білими літерами,
 * з рубрикою на тон світлішою, ніж на білому (teal-700 на slate-950 тоне).
 *
 * Роздільника з ромбами перед шапкою більше немає. Він з'явився тоді, коли
 * секції відрізнялися лише тлом на два відсотки яскравості; тепер межу між
 * розділами видно й без нього, а ромби над кожним заголовком стали б шумом.
 */
const SectionHeading = ({ title, caption, description, badge, tone = 'light' }) => {
  const dark = tone === 'dark';

  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
      <div>
        {caption && (
          <div className="flex items-center gap-3 mb-3">
            <span className="w-8 h-px bg-gradient-to-r from-teal-500 to-sky-400 flex-shrink-0"></span>
            <span
              className={`uppercase tracking-[0.2em] text-[0.7rem] sm:text-xs font-semibold ${
                dark ? 'text-teal-300' : 'text-teal-700'
              }`}
            >
              {caption}
            </span>
          </div>
        )}

        <h2
          className={`text-[1.75rem] sm:text-3xl lg:text-[2.5rem] font-extrabold font-display leading-[1.15] tracking-tight ${
            dark ? 'text-white' : 'text-slate-900'
          }`}
        >
          {title}
        </h2>

        {description && (
          <p className={`mt-4 max-w-3xl text-base leading-relaxed ${dark ? 'text-slate-300' : 'text-slate-600'}`}>
            {description}
          </p>
        )}
      </div>

      {/* Велике число — водяний знак, а не зміст: кількість пунктів і так
          видно з самих пунктів, тож диктору його не читаємо. */}
      {badge && (
        <div className="hidden lg:flex flex-col items-end text-right flex-shrink-0" aria-hidden="true">
          <div className={`text-3xl font-extrabold font-display ${dark ? 'text-white/[0.15]' : 'text-slate-200'}`}>
            {badge.value}
          </div>
          <div className={`text-xs uppercase tracking-wider ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
            {badge.label}
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionHeading;
